import React, { useEffect, useState, useCallback } from "react";
import {
  GoogleMap,
  useLoadScript,
  Marker,
  InfoWindow,
  Polyline,
} from "@react-google-maps/api";
import socketIO from "../../helpers/socket";
import { getClient, resetClientState } from "../../store/client/action";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty, clone } from "lodash";
import dummyImg from "../../assets/images/iot_device.png";
import { api } from "../../config";

const libraries = ["drawing"];
const mapContainerStyle = {
  width: "100vw",
  height: "100vh",
};
const center = {
  lat: -6.2240456,
  lng: 118.0148634,
};

const io = socketIO.getInstance();
io.setHost("https://socket.atapteknologi.id");
const socket = io.getSocket();
const App = () => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "AIzaSyD0auKcsMNas3qbqi-BgF_s3UxwtQNP74Q",
    libraries,
  });
  const [isConnected, setIsConnected] = useState(socket.connected);
  const dispatch = useDispatch();
  const [branchArr, setBranchArr] = useState([]);
  const [groupData, setGroupData] = useState([]);
  const [deviceList, setDeviceList] = useState([]);
  const [uidEvents, setUidEvents] = useState([]);
  const [markers, setMarkers] = useState([]);
  const [mapRef, setMapRef] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [routes, setRoutes] = useState([]);
  const [infoWindowData, setInfoWindowData] = useState();
  const { clients } = useSelector((state) => ({
    clients: state.Client.clients,
  }));

  const lineSymbol = {
    path: "M 0,-1 0,1",
    strokeOpacity: 1,
    scale: 3,
  };

  const handleMarkerClick = (id, lat, lng, address) => {
    setMapRef({ lat, lng });
    setInfoWindowData({ id, address });
    setIsOpen(true);
  };

  useEffect(() => {
    if (isEmpty(clients)) {
      dispatch(resetClientState());
      dispatch(getClient());
    }
  }, [dispatch, isLoaded, clients]);

  useEffect(() => {
    function onConnect() {
      setIsConnected(true);
    }

    function onDisconnect() {
      setIsConnected(false);
    }

    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);

    return () => {
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
    };
  });

  useEffect(() => {
    if (!isEmpty(clients)) {
      let unitArr = [];
      let deviceArr = [];
      let branchArr = [];
      clients.forEach((client, i) => {
        client.cl_company.forEach((company) => {
          branchArr = [...branchArr, company.com_branch];
          company.com_branch.forEach((branch) => {
            unitArr = [...unitArr, ...branch.br_unit];
            branch.br_unit.forEach((unit) => {
              deviceArr = [...deviceArr, ...unit.un_device];
            });
          });
        });
      });
      setBranchArr(branchArr);
      setGroupData(unitArr);
      setDeviceList(deviceArr);
    }
  }, [clients]);

  const onUidEvent = useCallback(
    (value) => {
      const val = JSON.parse(value);
      const data = uidEvents.filter((item) => item.uid !== val.uid);

      data.push(val);
      setUidEvents(data);
      if (data) {
        data.forEach((element) => {
          if (element.gps) {
            setRoutes([
              ...routes,
              {
                uid: element.uid,
                lat: element.gps?.latitude,
                lng: element.gps?.longitude,
              },
            ]);
          }
        });
      }
    },
    [uidEvents, routes]
  );

  useEffect(() => {
    deviceList.forEach((element) => {
      socket.on(element.uid, onUidEvent);
    });

    return () => {
      deviceList.forEach((element) => {
        socket.off(element.uid, onUidEvent);
      });
    };
  }, [deviceList, uidEvents, onUidEvent]);

  useEffect(() => {
    let dataMark = [];
    groupData.forEach((group, groupIndex) => {
      group.un_device.forEach((device, deviceIndex) => {
        if (device.device_status.id === 2) {
          dataMark.push(device);
          setMarkers(dataMark);
        }
        uidEvents.forEach((element) => {
          if (device.uid === element.uid) {
            let dataR = [];
            routes.forEach((route) => {
              if (device.uid === route.uid) {
                dataR.push({ lat: route.lat, lng: route.lng });
              }
            });
            device.latitude = element.gps?.latitude;
            device.longitude = element.gps?.longitude;
            device.routes = dataR;
            device.device_parameter &&
              device.device_parameter.forEach((parameter, parameterIndex) => {
                if (element.message) {
                  const amount = element.message[parameter.value];
                  if (
                    parameter.value === "device_time" &&
                    element.message.device_time
                  ) {
                    var date1 = new Date(parameter.amount);
                    var date2 = new Date(element.device_time);
                    if (date1.getTime() > date2.getTime()) {
                      element.message.device_time = parameter.amount;
                    } else {
                      element.message.device_time = element.device_time;
                    }
                  }
                  if (
                    parameter.value === "datetime" &&
                    element.message.datetime
                  ) {
                    var date3 = new Date(parameter.amount);
                    var date4 = new Date(element.device_time);
                    if (date3.getTime() > date4.getTime()) {
                      element.message.datetime = parameter.amount;
                    } else {
                      element.message.datetime = element.device_time;
                    }
                  }
                  if (amount) {
                    groupData[groupIndex].un_device[
                      deviceIndex
                    ].device_parameter[parameterIndex].amount = amount;
                  } else if (amount === 0) {
                    groupData[groupIndex].un_device[
                      deviceIndex
                    ].device_parameter[parameterIndex].amount = "0";
                  }
                }
              });
          }
        });
      });
    });
  }, [uidEvents, groupData, routes]);

  if (loadError) {
    return <div>Error loading maps</div>;
  }

  if (!isLoaded) {
    return <div>Loading maps</div>;
  }

  return (
    <div>
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        zoom={isOpen ? 17 : 5}
        center={isOpen ? mapRef : center}
        options={{ draggableCursor: true }}
        mapTypeId="hybrid"
        onClick={() => setIsOpen(false)}
      >
        {markers
          ? markers.map((mark, markIdx) => {
              return (
                <div key={markIdx}>
                  {mark.routes ? (
                    <Polyline
                      path={mark.routes}
                      options={{
                        strokeColor: "#000000",
                        strokeOpacity: 0,
                        strokeWeight: 2,
                        icons: [
                          {
                            icon: lineSymbol,
                            offset: "0",
                            repeat: "15px",
                          },
                        ],
                      }}
                    />
                  ) : null}
                  <Marker
                    position={{
                      lat: parseFloat(mark.latitude),
                      lng: parseFloat(mark.longitude),
                    }}
                    title={mark.name}
                    icon={{
                      url:
                        mark.device_service &&
                        mark.device_service.name === "Fuel Management System"
                          ? require("../../assets/images/oil-tank.png")
                          : require("../../assets/images/tower.png"),
                      scaledSize: new window.google.maps.Size(30, 30),
                    }}
                    onClick={() => {
                      handleMarkerClick(
                        markIdx,
                        parseFloat(mark.latitude),
                        parseFloat(mark.longitude),
                        mark.name
                      );
                    }}
                  >
                    {isOpen && infoWindowData?.id === markIdx && (
                      <InfoWindow
                        onCloseClick={() => {
                          setIsOpen(false);
                        }}
                      >
                        <div>
                          <div className="d-flex">
                            <div className="justify-content-start">
                              <h3 className="text-primary">{mark.name}</h3>
                              <p className="m-0">
                                Location: {mark.latitude}, {mark.longitude}
                              </p>
                              <p className="m-0">UUID: {mark.uid}</p>
                              <p className="m-0 mb-3">Phone: {mark.phone}</p>
                            </div>
                            <div className="justify-content-end ms-3 mt-3">
                              <button
                                // onclick={onClickView(device)}
                                className="btn btn-primary"
                                type="button"
                                data-bs-toggle="offcanvas"
                                data-bs-target="#offcanvasExample"
                                aria-controls="offcanvasExample"
                              >
                                {"View"}
                              </button>
                            </div>
                          </div>
                          <img
                            alt=""
                            src={
                              mark.image
                                ? api.MEDIA_URL + "/media/" + mark.image
                                : dummyImg
                            }
                            className="img-thumbnail"
                            width="300"
                          />
                        </div>
                      </InfoWindow>
                    )}
                  </Marker>
                </div>
              );
            })
          : null}
      </GoogleMap>
    </div>
  );
};

export default App;
